module.exports = __webpack_public_path__ + "static/media/cp2.032fa34b.jpg";